import React from "react";
import { ApolloProvider } from "@apollo/client";

import CreatorProfileHeader from "./index";

import { apolloClient } from "js/apollo/apollo-client";

const DjangoTemplateCreatorProfileHeader = ({
    args: propsFromDjangoTemplate
}) => {
    return (
        <ApolloProvider client={apolloClient}>
            <CreatorProfileHeader username={propsFromDjangoTemplate.username} />
        </ApolloProvider>
    );
};

export default DjangoTemplateCreatorProfileHeader;
